// reducers/products.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  ClearCurrentProject,
  createNewProjectActions,
  CurrentProjectLoadActions as CurrentProjectLoadActions,
  ProjectsListActions,
  ProjectUpdateActions,
} from './projects.actions';

import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { OutlineItem, ProjectItem } from 'src/app/shared/models/base.models';
import { SystemProcessLoadingStatus } from 'src/app/shared/models/system.models';

// export interface ProductsOfferState extends EntityState<OfferItem> {}
export interface ProjectState extends EntityState<ProjectItem> {
  currentProject: ProjectItem;
  currentProjectLoaded: { item: SystemProcessLoadingStatus };
  createNewProjectProcess: {
    status: SystemProcessLoadingStatus;
    error: any;
    lastCreatedProduct: ProjectItem | undefined;
  };
  projectUpdateProcess: { projectId?: number,status: SystemProcessLoadingStatus; error: any };
  loaded: boolean;
  error: any;
}

export const projectsAdapter = createEntityAdapter<ProjectItem>();
// export const productOfferAdapter = createEntityAdapter<OfferItem>();

const initialState: ProjectState = projectsAdapter.getInitialState({
  currentProject: undefined,
  currentProjectLoaded: { item: 'none', outline: 'none' },
  createNewProjectProcess: {
    status: 'none',
    error: null,
    lastCreatedProduct: undefined,
  },
  projectUpdateProcess: { projectId: undefined, status: 'none', error: null },

  loaded: false,
  error: null,
});

export const projectsReducer = createReducer(
  initialState,

  // ? Products List Related

  on(createNewProjectActions.create, (state, { createPayload }) => {
    return {
      ...state,
      createNewProjectProcess: {
        status: 'loading',
        error: undefined,
        lastCreatedProduct: undefined,
      },
    };
  }),
  on(createNewProjectActions.createSuccess, (state, { project }) => {
    console.log('Added Project', project);
    return projectsAdapter.addOne(project, {
      ...state,
      createNewProjectProcess: {
        status: 'done',
        error: undefined,
        lastCreatedProduct: project,
      },
    });
  }),
  on(createNewProjectActions.createFailure, (state, { error }) => {
    return {
      ...state,
      createNewProjectProcess: {
        status: 'error',
        error: error.message,
        lastCreatedProduct: undefined,
      },
    };
  }),

  on(ProjectsListActions.load, (state) => {
    return {
      ...state,
      loaded: false,
    };
  }),
  on(ProjectsListActions.loadSuccess, (state, { projects }) => {
    console.log(projects);
    return projectsAdapter.setAll(projects, { ...state, loaded: true });
  }),
  on(ProjectsListActions.loadFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // ! Current Product Related Actions​
  // ? Current Product Management
  on(CurrentProjectLoadActions.load, (state) => {
    return {
      ...state,
      currentProjectLoaded: { ...state.currentProjectLoaded, item: 'loading' },
    };
  }),
  on(CurrentProjectLoadActions.loadSuccess, (state, { project }) => {
    return {
      ...state,
      currentProject: project,
      currentProjectLoaded: { ...state.currentProjectLoaded, item: 'done' },
    };
  }),
  on(CurrentProjectLoadActions.loadFailure, (state, { error }) => ({
    ...state,
    error,
    currentProjectLoaded: {
      ...state.currentProjectLoaded,
      item: 'error',
      error: error.message,
    },
  })),

  // Project Update Section
  on(ProjectUpdateActions.update, (state, {projectId}) => {
    return {
      ...state,
      projectUpdateProcess: {projectId, status: 'updating', error: undefined },
    };
  }),
  on(ProjectUpdateActions.success, (state, { project }) => {
    if (!project) return state;
    if (project.id == state.currentProject.id) {
      return projectsAdapter.updateOne(
        { id: project.id, changes: project },
        {
          ...state,
          currentProject: project,
          projectUpdateProcess: {projectId: project.id, status: 'done', error: undefined },
        }
      );
    }
    else {
      return projectsAdapter.updateOne(
        { id: project.id, changes: project }, state
      );
    }
  }),
  on(ProjectUpdateActions.failure, (state, { error }) => ({
    ...state,
    error,
    projectUpdateProcess: {
      ...state.currentProjectLoaded,
      status: 'error',
      error: error.message,
    },
  })),

  // Project Content Section

  // on(deleteProduct, (state, { product }) =>
  //   productAdapter.removeOne(product.id, { ...state, loading: false })
  // ),
  // on(forgetSession, clearCurrentProduct, (state) => initialState)
  on(ClearCurrentProject, (state) => initialState)
);
